<template>
  <div>
    <servicos-modal v-if="modalSelecionarServico" v-model="modalSelecionarServico" permiteSelecionar
                    @selecionarServico="selecionarServico"
                    @fecharModalServicos="fecharModalServico"/>
    <servico-atendimento-cadastro-modal
        v-if="modalAdicionarServico"
        v-model="modalAdicionarServico"
        :atendimentoId="idAtendimento"
        :servico="servicoSelecionado"
        @fecharModalCadastrarServicoAtendimento="fecharModalAdicionarServico"
        @fecharModalCadastroServicoAtendimento="fecharModalCadastroServico"
    />
    <servico-atendimento-editar-modal
        v-if="modalEditarServicoAtendimento"
        v-model="modalEditarServicoAtendimento"
        :servicoAtendimento="servicoAtendimentoSelecionado"
        :atendimentoId="idAtendimento"
        @fecharModalEditarServicoAtendimento="fecharModalEdicaoServico"
    />
    <div class="header-gerenciamento-servicos">
      <span class="primary--text">Gerenciamento de serviços</span>
    </div>
    <div class="container-acoes-servicos" v-if="statusAtendimento === 'EM_ANDAMENTO'">
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="primary" depressed @click="adicionarServico">
            <v-icon>build</v-icon>
          </v-btn>
        </template>
        Adicionar serviço
      </v-tooltip>
      <div class="container-total">
        <span>Total</span><br/>
        <label>{{ valorTotalGeral | valorParaReal }}</label>
      </div>
    </div>
    <v-container fluid grid-list-xl white class="pa-0">
      <odontograma-gerenciar-servicos-atendimento-tabela
          :itens="itens"
          :paginas="paginas"
          :total-itens="totalItens"
          :paginacao="$store.state.servicoAtendimento.resultadoBuscaTodosServicosAtendimento.paginacao"
          @acessar="tratarEventoAcessarServico"
          @paginar="tratarEventoPaginar"
      />
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'
import {actionTypes, mutationTypes} from '@/core/constants'
import ServicosModal from '@/views/modais/servicos/ServicosModal.vue'
import ServicoAtendimentoCadastroModal
from '@/views/pages/cadastros/paciente/comum/odontograma/servicos/ServicoAtendimentoCadastroModal.vue'
import OdontogramaGerenciarServicosAtendimentoTabela
from '@/views/pages/cadastros/paciente/comum/odontograma/servicos/OdontogramaGerenciarServicosAtendimentoTabela.vue'
import ServicoAtendimentoEditarModal
from '@/views/pages/cadastros/paciente/comum/odontograma/servicos/ServicoAtendimentoEditarModal.vue'

export default {
    name: 'OdontogramaGerenciarServicos',
    props: {
        idAtendimento: {
            type: Number,
            required: true
        },
        statusAtendimento: {
            type: String,
            required: true
        },
    },
    components: {
        ServicoAtendimentoEditarModal,
        OdontogramaGerenciarServicosAtendimentoTabela,
        ServicoAtendimentoCadastroModal,
        ServicosModal
    },
    data() {
        return {
            filtrosInterno: this.getFiltros(),
            modalSelecionarServico: false,
            modalAdicionarServico: false,
            modalEditarServicoAtendimento: false,
            servicoAtendimentoSelecionado: null,
            itens: [],
            paginas: 0,
            totalItens: 0,
            valorTotalGeral: 0,
            servicoSelecionado: null
        }
    },
    methods: {
        async buscar() {
            this.$store.commit(mutationTypes.SERVICO_ATENDIMENTO.SET_FILTROS_BUSCA_TODOS_SERVICOS_ATENDIMENTO, this.getFiltrosInterno())
            await this.buscarServicos()
        },
        async buscarServicos() {
            const resposta = await this.$store.dispatch(actionTypes.SERVICO_ATENDIMENTO.BUSCAR_TODOS_SERVICOS, this.idAtendimento)
            if (resposta) {
                this.itens = resposta.items
                this.paginas = resposta.totalPages
                this.totalItens = resposta.totalElements
                this.valorTotalGeral = resposta.valorTotalGeral
            }
        },
        getFiltros() {
            return _.cloneDeep(this.$store.state.servicoAtendimento.resultadoBuscaTodosServicosAtendimento.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        tratarEventoPaginar(paginacao) {
            this.$store.commit(mutationTypes.SERVICO_ATENDIMENTO.SET_PAGINACAO_BUSCA_TODOS_SERVICOS_ATENDIMENTO, paginacao)
            this.buscar()
        },
        tratarEventoAcessarServico(item) {
            this.servicoAtendimentoSelecionado = item
            this.modalEditarServicoAtendimento = true
        },
        fecharModalEdicaoServico() {
            this.modalEditarServicoAtendimento = false
            this.servicoAtendimentoSelecionado = null
            this.buscar()
        },
        adicionarServico() {
            this.modalSelecionarServico = true
        },
        fecharModalServico() {
            this.modalSelecionarServico = false
        },
        selecionarServico(item) {
            this.fecharModalServico()
            this.servicoSelecionado = item
            this.modalAdicionarServico = true
        },
        fecharModalAdicionarServico() {
            this.modalAdicionarServico = false
            this.servicoSelecionado = null
            this.adicionarServico()
        },
        fecharModalCadastroServico() {
            this.modalAdicionarServico = false
            this.servicoSelecionado = null
            this.buscar()
        }
    }
}
</script>

<style scoped lang="stylus">

.header-gerenciamento-servicos
  margin-top 10px
  border-bottom 1px solid #ddd

  span
    font-weight bold

.container-acoes-servicos
  margin-top 10px
  display flex
  justify-content space-between

.container-total
  span
    font-weight bold
    color var(--theme-primary)

</style>